module.exports = __webpack_public_path__ + "img/empty-notify.858c56cd.svg";